var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4908 6.91247H4.47887L9.91727 12.5752L11.4866 14.1643C10.6328 13.9691 10.5799 13.8475 10.2016 13.5386C10.0031 13.3765 9.61966 12.9361 9.03728 12.3414C7.21942 10.4851 4.13477 7.33519 4.13477 7.33519V16.655L4.52219 17.0424L4.47883 17.0875L11.3752 23.9839C11.582 23.9945 11.7902 24 11.9996 24C18.627 24 23.9996 18.6274 23.9996 12C23.9996 11.801 23.9944 11.6032 23.9849 11.4065L19.4908 6.91247Z",
    fill: "#EBDCEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13477 7.33519V16.655L8.67967 11.9762L4.13477 7.33519Z",
    fill: "#2E1834"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8641 7.33519V16.655L15.3418 11.9951L19.8641 7.33519Z",
    fill: "#2E1834"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47852 6.91247H19.4905L13.5905 13.0558C13.1706 13.493 12.5907 13.7401 11.9845 13.7401C11.3784 13.7401 10.7984 13.493 10.3785 13.0558L4.47852 6.91247Z",
    fill: "#2E1834"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9309 13.3826C13.4247 13.9097 12.7153 14.212 11.9845 14.212C11.2538 14.212 10.5443 13.9098 10.0382 13.3827L9.03744 12.3406L4.47852 17.0875H19.4905L14.9316 12.3406L13.9309 13.3826Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email 1.536629d78895ad96ac8c2600d43fc835.svg";
export { ForwardRef as ReactComponent };